import React, { useEffect } from 'react';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/*-----Minor Alignment and Condition section---*/}
      <section className="mt-10 hm-one" style={{paddingTop: "25px"}}>
        <div className="container">
            <div className="row">
                <div className="alert alert-success">
                    Revival Pharmacy offers comprehensive assessment and treatment for various minor ailments. Our skilled pharmacists are equipped to address the following conditions. Visit our pharmacy for a thorough assessment if you're experiencing symptoms related to any of these minor ailments:
                </div>
                <div className="row col-md-12">
                    <div className="col-lg-6">
                        <div className="preventions">
                            <ul>
                                <li>Athlete’s Foot</li>
                                <li>Allergic Rhinitis (Seasonal Allergies)</li>
                                <li>Atopic Dermatitis (Eczema)</li>
                                <li>Bladder Infections</li>
                                <li>Canker Sore</li>
                                <li>Cold Sore</li>
                                <li>COVID-19</li>
                                <li>Diaper Rash</li>
                                <li>Emergency Contraception</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="preventions">
                            <ul>
                                <li>Erectile Dysfunction</li>
                                <li>Muscle Strains and Sprains</li>
                                <li>Oral Thrush</li>
                                <li>Painful Menstruation</li>
                                <li>Pink Eye - Viral, Bacterial, and Allergic</li>
                                <li>Quitting Nicotine</li>
                                <li>Ringworm</li>
                                <li>Recurrent Genital Herpes</li>
                                <li>Shingles</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>


    <section className="">
        <div className="container">
            <div className="request_consult_inner">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="request_consult_left">
                            <h2>Revival Pharmacy is a leading life sciences </h2>
                            <p>One goal of our Pharmacy is to be there when you need us. </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
      </section>
    </>
  );
}
